import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Api from '../../../service/Api';
import '../Component1/Component1.css';

import { questionsData, questionsData_en } from '../../../translate/comp1_questions.js';


export const allQuestions = {
  en: typeof questionsData_en !== 'undefined' ? questionsData_en : [], // Fallback caso não esteja definido
  pt: typeof questionsData !== 'undefined' ? questionsData : []
};

function Component1() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();

  // Estados
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Seleção dinâmica do conjunto de perguntas baseado no idioma do i18next
  const currentQuestions = useMemo(() => {
    const lang = i18n.language?.split('-')[0] || 'pt';
    return allQuestions[lang] || allQuestions['pt'];
  }, [i18n.language]);


  useEffect(() => {
    setSelectedOption(answers[currentQuestionIndex]?.answer || null);
  }, [currentQuestionIndex, answers]);

  const handleAnswerChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleNextQuestion = () => {
    // Validação: deve selecionar uma opção ou estar na última tela
    if (selectedOption) {
      const newAnswers = [...answers];
      newAnswers[currentQuestionIndex] = {
        title: currentQuestions[currentQuestionIndex].title,
        subtitle: currentQuestions[currentQuestionIndex].subtitle,
        question: currentQuestions[currentQuestionIndex].question,
        answer: selectedOption
      };
      
      setAnswers(newAnswers);
      
      if (currentQuestionIndex < currentQuestions.length - 1) {
        setCurrentQuestionIndex(currentQuestionIndex + 1);
        // O useEffect acima cuidará de resetar ou recuperar o selectedOption
      } else {
        setIsComplete(true);
      }
    } else {
      window.alert(t('Por favor, selecione uma resposta antes de continuar.'));
    }
  };

  const handlePreviousQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleSubmit = async () => {
    if (isLoading) return;
    setIsLoading(true);

    // Garante que a última resposta seja incluída antes de enviar
    let finalAnswers = [...answers];
    if (selectedOption) {
      finalAnswers[currentQuestionIndex] = {
        title: currentQuestions[currentQuestionIndex].title,
        subtitle: currentQuestions[currentQuestionIndex].subtitle,
        question: currentQuestions[currentQuestionIndex].question,
        answer: selectedOption,
      };
    }

    try {
      const infoUser = localStorage.getItem("infoUser");
      const user = JSON.parse(infoUser);
      
      await Api.respostapesquisa({
        id: user.id,
        respostas: finalAnswers
      });

      window.alert(t("resposta enviada com sucesso !!!"));
      navigate('/home');
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data.error;
        window.alert(errorMessage);
      } else {
        console.error("Erro ao enviar dados para a API:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Se os dados ainda não carregaram ou estão vazios
  if (!currentQuestions || currentQuestions.length === 0) {
    return <div>Loading questions...</div>;
  }

  return (
    <div className="container-cp1">
      <div className='text-container-cp1'>
        {!isComplete ? (
          <div>
            <div>
              <h2 className='title-cp1'>{currentQuestions[currentQuestionIndex].title}</h2>
              <p className='title-cp1'>{currentQuestions[currentQuestionIndex].subtitle}</p>
              <p className='question-cp1'>{currentQuestions[currentQuestionIndex].question}</p>
              
              {currentQuestions[currentQuestionIndex].options.map((option, index) => (
                <label key={index}>
                  <div className='alternative-cp1'>
                    <input
                      type="radio"
                      name="option"
                      value={option.charAt(0)} // Captura 'A', 'B', 'C' ou 'D'
                      checked={selectedOption === option.charAt(0)}
                      onChange={handleAnswerChange}
                    />
                    {option}
                  </div>
                </label>
              ))}
            </div>

            <div className="button-container-cp1">
              <button 
                className="button-cp1" 
                onClick={handlePreviousQuestion} 
                disabled={currentQuestionIndex === 0}
              >
                {t('Voltar')}
              </button>
              <button className="button-cp1" onClick={handleNextQuestion}>
                {currentQuestionIndex < currentQuestions.length - 1 ? t('Próxima') : t('Finalizar')}
              </button>
            </div>
          </div>
        ) : (
          <div className="submit-container">
            <button className="button-cp1" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? t('Enviando...') : t('Enviar Respostas')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Component1;






